import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '../../client-config/services/config.service';
import { LocalizeContacts } from '../../../core/shared/localize-config';
import { AuthService } from '../../auth/services/auth.service';
import { forkJoin, Subscription } from 'rxjs';
import { CodeEnum } from 'src/app/core/shared/enums/codeEnum';
import { AccountStatusEnum } from 'src/app/core/models/account-status.enum';
import AccountUserInfo from 'src/app/core/models/AccountUserInfo';
import { ChooseActorService } from '../../auth/services/choose-actor.service';
import { CardService } from 'src/app/core/services/card.service';
import { OrganizationType } from 'src/app/core/shared/enums/organizationType';
import { OrgTypeEnum } from 'src/app/core/shared/enums/type-of-subject.enum';

@Component({
  selector: 'norights',
  templateUrl: './norights.component.html',
  styleUrls: ['./norights.component.scss'],
})
export class NorightsComponent implements OnInit, OnDestroy {
  private subs: Subscription = new Subscription();
  contacts: LocalizeContacts;
  isLoading = true;
  isPhoneConfirmed: boolean = true;
  isMailConfirmed: boolean = false;
  norightsInstructionHref: string;
  accountStatus: AccountStatusEnum | null | undefined;
  AccountStatusEnum = AccountStatusEnum;
  userInfo: AccountUserInfo | undefined = undefined;
  isStranger: boolean = false;
  isDetached: boolean = false;
  signinOnlyVerifiedOrg: boolean = false;

  constructor(
    private configService: ConfigService,
    public authService: AuthService,
    private chooseActorService: ChooseActorService,
    private cardService: CardService
  ) {
    this.contacts = configService.localizeContacts;
    this.norightsInstructionHref = this.configService.customization.getOptionString(CodeEnum.NORIGHTS_INSTRUCTION_HREF);
    this.signinOnlyVerifiedOrg = this.configService.customization.getOptionBool(CodeEnum.SIGIN_ONLY_VERIFIED_ORG);
  }

  ngOnInit(): void {
    if (!this.authService.isAuthenticated()) return;

    this.subs.add(
      this.authService.getUserInfo()
        .subscribe((userInfo) => {
          this.userInfo = userInfo;
          this.isPhoneConfirmed = userInfo.isPhoneConfirmed == true;
          this.isMailConfirmed = userInfo.isEmailConfirmed == true;
          this.isLoading = false;
          this.accountStatus = userInfo.accountStatus;

          this.isStranger = this.authService.GetUserAccountType() === 'stranger';
          this.loadOrganizations();
        })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private loadOrganizations() {
    this.isLoading = true;

    if (this.isStranger) {
      this.loadStrangerOrganizations();
    } else {
      this.loadRegularOrganizations();
    }
  }

  private loadRegularOrganizations() {
    this.subs.add(
      forkJoin([
        this.chooseActorService.getUserOrgs(),
        this.cardService.getPermission()
      ])
        .subscribe({
          next: ([orgs, permissions]) => {
            const hasActiveOrg = orgs.some(org => {
              const roles = permissions
                .filter(p => p.organization.id === org.id)
                .map(p => p.clientRoles.role);

              const hasRoles = roles.length > 0;

              const isOrgDisabled = this.signinOnlyVerifiedOrg &&
                org.status !== OrganizationType.VERIFIED &&
                org.type !== OrgTypeEnum.Physical;

              return hasRoles && !isOrgDisabled;
            });

            this.isDetached = !hasActiveOrg;
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Ошибка получения данных:', error);
            this.isLoading = false;
          }
        })
    );
  }

  private loadStrangerOrganizations() {
    this.subs.add(
      this.chooseActorService.getStrangerOrgs()
        .subscribe({
          next: (result) => {
            this.isDetached = result.every((item) => !item.organizationIsActive);
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Ошибка получения данных для stranger:', error);
            this.isLoading = false;
          }
        })
    );
  }
}
